import { render } from "./AfterPayment.vue?vue&type=template&id=38969b3b"
import script from "./AfterPayment.vue?vue&type=script&lang=js"
export * from "./AfterPayment.vue?vue&type=script&lang=js"

import "./AfterPayment.vue?vue&type=style&index=0&id=38969b3b&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__